import {Component, EventEmitter, inject, Input, Output} from "@angular/core";
import {CommonModule} from "@angular/common";
import {Router, RouterModule} from "@angular/router";

@Component({
    selector: "app-save-cancel-buttons",
    standalone: true,
    imports: [CommonModule, RouterModule],
    template: `
        <div class="admin-form-actions d-flex">
            <button
                    class="cancel-input btn btn-qundis-secundary qundis-btn-layer2 me-2 p-2 d-flex align-items-center"
                    (click)="onCancel()"
            >
                <span>Verwerfen</span>
                <i class="bi bi-x"></i>
            </button>
            <button
                    class="confirm-input btn btn-qundis-primary qundis-btn-layer2 ms-2 d-flex align-items-center"
                    (click)="onSave()"
                    [disabled]="!this.isFormValid"
            >
                <span>Speichern</span>
                <i class="bi bi-check"></i>
            </button>
        </div>
    `,
    styles: [],
})
export class SaveCancelButtonsComponent {
    @Input() backRoute: string;
    @Input() isFormValid: boolean = true;
    @Output() saveEvent = new EventEmitter<void>();
    @Output() cancelEvent = new EventEmitter<void>();
    router = inject(Router);

    onSave() {
        this.saveEvent.emit();
    }

    onCancel() {
        if (this.backRoute) {
            this.router.navigate([this.backRoute]);
        }
        this.cancelEvent.emit();
    }
}
